import { forwardRef } from "react";

import { TextInput, TextInputRef } from "../TextInput";
import { SearchInputProps } from "./types";
import { Search } from "../../../assets";
import { Cross } from "../../../assets/svg/Cross";

export const SearchInput = forwardRef<TextInputRef, SearchInputProps>(
  ({ value, setValue = () => null, showLeftIcon = true, ...rest }, ref) => {
    const clearInput = () => {
      setValue("");
    };

    return (
      <TextInput
        ref={ref}
        value={value}
        onRightIconClick={clearInput}
        onChangeText={(text) => setValue(text)}
        {...(showLeftIcon && { leftIcon: <Search /> })}
        {...(value && { rightIcon: <Cross /> })}
        {...rest}
      />
    );
  }
);
